import React, { useState } from 'react';

const MemorialTimeline = ({ memorial }) => {
  const [expandedEventId, setExpandedEventId] = useState(null);
  
  // Debug logging
  
  
  
  // Don't render anything if no timeline events
  if (!memorial?.timelineEvents || memorial.timelineEvents.length === 0) {
    
    return null;
  }

  // All boxes will be white with gray border

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };



  const toggleEvent = (eventId) => {
    setExpandedEventId(expandedEventId === eventId ? null : eventId);
  };

  // Sort events by date
  const sortedEvents = [...memorial.timelineEvents].sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div className="bg-white rounded-none p-6 md:p-10 mb-8 border border-[#eee9df]">
      <div className="text-center mb-10">
        <p className="text-[10.5px] uppercase" style={{ letterSpacing: '0.34em', color: '#b8964f' }}>
          Their Journey
        </p>
        <h2 className="mt-3 text-2xl md:text-3xl font-extralight text-gray-900" style={{ letterSpacing: '0.04em' }}>
          Life Timeline
        </h2>
        <div
          className="mx-auto mt-4"
          style={{ width: '54px', height: '1px', background: 'linear-gradient(90deg, transparent, #cbab6a, transparent)' }}
        />
        <p className="mt-4 text-gray-500 text-sm font-light">
          Important moments from {memorial.firstName}'s journey
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-0 md:left-0 top-0 bottom-0 w-px" style={{ background: 'linear-gradient(180deg, transparent, #cbab6a 12%, #cbab6a 88%, transparent)', opacity: 0.5 }}></div>

          {/* Timeline events */}
          <div className="space-y-8 md:space-y-10">
            {sortedEvents.map((event, index) => {
              const isExpanded = expandedEventId === (event.id || index);
              
              return (
                <div key={event.id || index} className="relative group">
                  {/* Timeline dot */}
                  <div
                    className="absolute -left-1.5 md:-left-1.5 w-3 h-3 rounded-full z-10 group-hover:scale-125 transition-transform duration-200"
                    style={{ background: '#e5c883', boxShadow: '0 0 10px 2px rgba(255,215,140,0.55)' }}
                  ></div>
                  
                  {/* Event content */}
                  <div className="ml-8 md:ml-12">
                    <div 
                      className={`p-6 md:p-8 bg-white rounded-2xl border cursor-pointer transition-all duration-300 hover:border-[#d8c9a4] hover:shadow-[0_10px_40px_rgba(184,150,79,0.12)] ${isExpanded ? 'border-[#cbab6a] shadow-[0_10px_40px_rgba(184,150,79,0.12)]' : 'border-[#eee9df]'}`}
                      onClick={() => toggleEvent(event.id || index)}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="mb-2">
                            <p className="text-[10px] md:text-[11px] uppercase mb-1" style={{ letterSpacing: '0.28em', color: '#b8964f' }}>
                              {event.type}
                            </p>
                            <h3 className="text-xl md:text-2xl font-extralight text-gray-900" style={{ letterSpacing: '0.03em' }}>
                              {event.title}
                            </h3>
                            <p className="text-xs md:text-sm text-gray-500 font-light mt-1.5" style={{ letterSpacing: '0.12em' }}>
                              {formatDate(event.date)}
                            </p>
                          </div>
                          
                          {event.description && (
                            <div className={`overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-96' : 'max-h-20'}`}>
                              <p className="text-gray-700 leading-relaxed text-sm md:text-base mt-4">
                                {isExpanded ? 
                                  event.description : 
                                  (event.description.length > 120 ? 
                                    `${event.description.slice(0, 120)}...` : 
                                    event.description)
                                }
                              </p>
                            </div>
                          )}
                        </div>
                        
                        {/* Expand/Collapse indicator */}
                        <div className="ml-4 flex items-center justify-center w-6 h-6 md:w-8 md:h-8">
                          <svg 
                            className={`w-4 h-4 transition-all duration-300 ${isExpanded ? 'rotate-90' : ''}`}
                            style={{ color: '#b8964f' }} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                          </svg>
                        </div>
                      </div>
                      
                      {/* Expanded content footer */}
                      {isExpanded && event.description && event.description.length > 120 && (
                        <div className="mt-6 pt-4 border-t border-[#f3efe6]">
                          <button 
                            className="text-xs uppercase text-gray-500 hover:text-black underline underline-offset-4 transition-colors duration-200" style={{ letterSpacing: '0.2em' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleEvent(event.id || index);
                            }}
                          >
                            Show less
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemorialTimeline;